export default __webpack_public_path__ + "5ec3380d26af9f7e559bf1419d6f8ed6.png";